import { IntlProvider } from 'react-intl'
import type { ReactNode } from 'react'
import enCA from './en-CA.json'
import frCA from './fr-CA.json'

const MESSAGES = {
  'en-CA': enCA,
  'fr-CA': frCA,
} as const

type Locale = keyof typeof MESSAGES

interface I18nProviderProps {
  locale: Locale
  children: ReactNode
}

export function I18nProvider({ locale, children }: I18nProviderProps) {
  return (
    <IntlProvider locale={locale} messages={MESSAGES[locale]}>
      {children}
    </IntlProvider>
  )
}
